import { useState } from 'react';
import { faKey, faSpinner, faUser, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames/bind';
import { useStore } from '~/components/Hook';
import { auth, getToken } from '~/services/authService';
import styles from './Register.module.scss';

const cx = classNames.bind(styles);
function RegisterForm(data) {
    const [logError, setLogError] = useState(false);
    const [loading, setLoading] = useState(false);
    const store = useStore();
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        const token = await getToken();
        const dataAuth = {
            username: e.target.username.value,
            password: e.target.password.value,
            _csrf: token,
            setError: setLogError,
        };
        const res = await auth(dataAuth);
        if (res) {
            store.storage.setData({ jobs: res.jobs });
            store.dispatch(store.actions.setAcc(res));
        }
        setLoading(false);
    };
    return (
        <div className={cx('container')}>
            <div className={cx('card')}>
                <div className={cx('card-header')}>
                    <h3>Login</h3>
                    {loading && <FontAwesomeIcon className={cx('loading')} icon={faSpinner} />}
                </div>

                <div className={cx('card-body')}>
                    {logError && (
                        <section className={cx('errors')}>
                            <FontAwesomeIcon fontSize={'20px'} icon={faWarning} />
                            <div className={cx('alert-login-fail')}>{logError}</div>
                        </section>
                    )}
                    <form onSubmit={handleSubmit} className={cx('input-from')}>
                        <div className={cx('input-group')}>
                            <div className={cx('input-group-prepend')}>
                                <span className={cx('input-group-text')}>
                                    <FontAwesomeIcon fontSize={'16px'} icon={faUser} />
                                </span>
                            </div>
                            <input type="text" name="username" className={cx('form-control')} placeholder="Username" />
                        </div>
                        <div className={cx('input-group')}>
                            <div className={cx('input-group-prepend')}>
                                <span className={cx('input-group-text')}>
                                    <FontAwesomeIcon fontSize={'16px'} icon={faKey} />
                                </span>
                            </div>
                            <input
                                type="password"
                                name="password"
                                className={cx('form-control')}
                                placeholder="Password"
                            />
                        </div>

                        <input type="hidden" name="_csrf" value={data.csrfToken} />
                        <div className="form-group">
                            <input type="submit" value="Login" className={cx('login_btn', { disabled: loading })} />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default RegisterForm;
